function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { is } from '@itsjonq/is';
import { useCallback, useMemo, useState } from 'react';
import warning from 'tiny-warning';

/**
 * A enhanced hook for managing boolean states.
 *
 * @param {boolean} initialValue An initial state value.
 *
 * @example
 * const [state, stateFns] = useBoolState(false);
 * ...
 * stateFns.toggle(); // Toggles the state.
 */
export function useBoolState(initialState) {
  process.env.NODE_ENV !== "production" ? warning(is.boolean(initialState), ['use-enhanced-state', 'useBoolState', 'State must be a boolean.'].join('\n')) : void 0;

  var _useState = useState(initialState || false),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var truthy = useCallback(function () {
    return setState(true);
  }, []);
  var falsy = useCallback(function () {
    return setState(false);
  }, []);
  var toggle = useCallback(function () {
    return setState(function (prev) {
      return !prev;
    });
  }, []);
  var methods = useMemo(function () {
    return {
      false: falsy,
      falsy: falsy,
      set: setState,
      setState: setState,
      toggle: toggle,
      true: truthy,
      truthy: truthy
    };
  }, [falsy, toggle, truthy]);
  return [state, methods];
}